import { Subscription } from 'rxjs';
import { MerchantsComponent } from './../merchants/merchants.component';
import { Component, OnInit, OnDestroy, Injector } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-merchant-settlement',
  templateUrl: './merchant-settlement.component.html',
  styleUrls: ['./merchant-settlement.component.css']
})
export class MerchantSettlementComponent
  extends MerchantsComponent
  implements OnInit, OnDestroy
{
  settlementDetail: any = null;
  settlementHistoryDetails: any[] = [];
  dataLoading = false;
  minDPDate: Date;
  maxDPDate: Date;
  isAutoSettleTypeError = false;
  saving = false;
  filterSettlementTypes = [];
  settlementSchedules = [
    { id: 'D', value: 'Daily' },
    { id: 'W', value: 'Weekly' },
    { id: 'M', value: 'Monthly' }
  ];
  settlementTypes = [
    { id: 'NC', value: 'Navy Cash Strip Account', merchantType: 'PVT' },
    { id: 'ACH', value: 'Linked Bank Account', merchantType: 'PVT' },
    { id: 'DO', value: 'Navy Disbursing', merchantType: 'TRANS' },
    { id: 'MAN', value: 'Manual', merchantType: '' }
  ];
  merchantType: string;
  merchantNum: string;
  shipLocation: string;
  settlementDetailCurrent: string;
  applyBalanceButtonSpinnerString = '';
  loadingHistory = false;
  transactionDateRange = 35; // This should reflex what is in TransactionController.java
  startDate: NgbDate;
  endDate: NgbDate;
  maxDate: NgbDate;
  merchantAccountInfoSub: Subscription;

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.endDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.maxDate = new NgbDate(this.endDate.year - 1, this.endDate.month, 1);
    this.dataLoading = true;
    this.merchantAccountInfoSub = this.merchantAccountInfoSet.subscribe(() => {
      this.merchantNum = this.merchant.ncMerchantNum.toString();
      this.shipLocation = this.merchant.location;
      this.dataLoading = false;
      // Merchant can get set from multiple sources and the structures from the backend
      // vary slightly hence the check for the existence of type before using merchantType
      this.merchantType = this.merchant.type
        ? this.merchant.type
        : this.merchant.merchantType;
      this.settlementTypes.forEach((type) => {
        if (this.merchantType === type.merchantType) {
          this.filterSettlementTypes.push(type);
        }
      });
      this.displayMerchantSettlement();
    });
  }

  ngOnDestroy() {
    this.merchantAccountInfoSub.unsubscribe();
  }

  displayMerchantSettlement() {
    this.loadSettlementData();
    this.loadSettlementHistory();
  }

  loadSettlementData() {
    this.isAutoSettleTypeError = false;
    this.dataLoading = true;
    this.merchantService
      .getSettlementDetails(this.merchantNum, this.shipLocation)
      .subscribe(
        (data) => {
          this.settlementDetail = data;
          this.settlementDetailCurrent = this.settlementDetail;
          this.dataLoading = false;
          if (
            this.merchantType === 'TRANS' &&
            this.settlementDetail.autoSettleType !== 'DO'
          ) {
            this.isAutoSettleTypeError = true;
          }
        },
        () => {
          this.dataLoading = false;
          this.messageService.error('Error in loading settlement data');
        }
      );
  }

  loadSettlementHistory() {
    this.loadingHistory = true;
    const startDateString = MerchantSettlementComponent.format(this.startDate);
    const endDateString = MerchantSettlementComponent.format(this.endDate);

    this.merchantService
      .loadSettlementHistory(
        this.merchantNum,
        this.shipLocation,
        startDateString,
        endDateString
      )
      .subscribe(
        (data: any[]) => {
          this.loadingHistory = false;
          this.settlementHistoryDetails = data;
        },
        () => {
          this.loadingHistory = false;
          this.messageService.error('Error in loading History');
        }
      );
  }

  saveMerchantSettlement(settlementData) {
    this.dataLoading = true;
    this.merchantService
      .saveMerchantSettlement(
        this.merchantNum,
        this.shipLocation,
        settlementData.autoSettleType,
        settlementData.autoSettleSchedule
      )
      .subscribe(
        (data: any) => {
          this.dataLoading = false;
          this.settlementDetail = data;
          this.settlementDetailCurrent = this.settlementDetail;
          this.messageService.success('Saved');
        },
        () => {
          this.dataLoading = false;
          this.messageService.error('Error in Saving');
        }
      );
  }

  getSettlementTypeString(type: string) {
    let settlementType = type;
    this.settlementTypes.forEach((elem) => {
      if (elem.id === type) {
        settlementType = elem.value;
      }
    });
    return settlementType;
  }

  getSettlementScheduleString(schedule: string) {
    let settlementSchedule = schedule;
    this.settlementSchedules.forEach((elem) => {
      if (elem.id === schedule) {
        settlementSchedule = elem.value;
      }
    });
    return settlementSchedule;
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
